import React from 'react';

const Badge = ({ text }) => {
  return (
    <span className='detail-badge' title={text}>
      {text}
    </span>
  )
}

export default Badge;
